import { DecimalPlaces } from "@coreapp/utils/DecimalPlaces";
import { LDecimalPlaces } from "@coreapp/utils/LDecimalPlaces";
import { Globals } from "@coreapp/CoreApp/Globals";
import { enumUnitVal, kDPIScreen, kCMI } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";

export const GetDecString = function (value, units = enumUnitVal.inches) {
  var conversion = 1;
  var decPlaces = 2;
  if (units === enumUnitVal.cm) {
    conversion = 2.54;
    decPlaces = 1;
  }

  var dpi = kDPIScreen;
  var target = (value / dpi) * conversion;

  return DecimalPlaces(target, decPlaces);
};

export const GetContentInches = function (v, units = enumUnitVal.inches) {
  v = v.replace(Globals._decimalMarker, ".");
  if (units === enumUnitVal.cm) {
    v = parseFloat(v);
    v = v / 2.54;
    v = LDecimalPlaces(v, 2);
  }
  return v;
};

export const GetUnitsString = function (units) {
  var theUnits = "";
  switch (units) {
    case enumUnitVal.pixels:
      theUnits = "px";
      break;
    case enumUnitVal.inches:
      theUnits = "in";
      break;
    case enumUnitVal.cm:
      theUnits = "cm";
      break;
    default:
      theUnits = "";
      break;
  }

  return theUnits;
};

export const formatPageSizeDimension = (dimension, scaleFactor) => {
  return (dimension / scaleFactor).toFixed(1).replace(/\.?0*$/, "");
};

export const buildPageSizes = (changeFunction, chartSizes, prefixId, additionalOptions) => {
  const sizes = Object.entries(chartSizes);
  const useEnglish = localStorage.getItem("unitSystem") === "English";
  const scaleFactor = useEnglish ? 96 : 96 / kCMI;
  const unitName = useEnglish ? " in" : " cm";

  let options = sizes.map(sizeObj => {
    const [value, pageSize] = sizeObj;
    const isCustomSize = value == "customps";
    const formattedWidth = formatPageSizeDimension(pageSize[0], scaleFactor);
    const formattedHeight = formatPageSizeDimension(pageSize[1], scaleFactor);
    const label = !isCustomSize
      ? `${appstr(value)} - ${formattedWidth} x ${formattedHeight}${unitName}`
      : appstr(value);

    return {
      label,
      value,
      dataTestId: `${prefixId}-${value}`,
      clickHandler: () => changeFunction(value)
    };
  });

  if (Object.keys(additionalOptions).length !== 0) {
    options.unshift(additionalOptions);
  }

  return options;
};

export const attachChangeAndLocalizate = (options, changeFunction) => {
  for (let i in options) {
    options[i].onChange = changeFunction;
    options[i].label = appstr(options[i].localLabel);
  }
  return options;
};

export const buildSelectProps = (sizes, changeFunction, otherProps, testPrefix) => {
  let propsObj = {
    ...otherProps,
    options: []
  };

  for (let key in sizes) {
    propsObj.options.push({
      label: appstr(key.toString()),
      value: key.toString(),
      dataTestId: `${testPrefix}-${key}`,
      clickHandler: changeFunction
    });
  }

  return propsObj;
};

export const buildHeaderFooterProps = (sizes, changeFunction, otherProps, testPrefix) => {
  let propsObj = {
    ...otherProps,
    options: []
  };

  for (let key of sizes) {
    propsObj.options.push({
      label: appstr(key.toString()),
      value: key.toString(),
      dataTestId: `${testPrefix}-${key}`,
      clickHandler: changeFunction
    });
  }

  return propsObj;
};

export const marginKeys = {
  marginTop: "fTop",
  marginRight: "fRight",
  marginLeft: "fLeft",
  marginBottom: "fBottom"
};
